require("intersection-observer");

import "defaults.css";
import "./style/index.styl";
import App from "./components/app";

export default App;



// WEBPACK FOOTER //
// ./index.js